import { render, staticRenderFns } from "./dataGeneration.vue?vue&type=template&id=89276a9a&scoped=true"
import script from "./dataGeneration.vue?vue&type=script&lang=js"
export * from "./dataGeneration.vue?vue&type=script&lang=js"
import style0 from "./dataGeneration.vue?vue&type=style&index=0&id=89276a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89276a9a",
  null
  
)

export default component.exports